module.exports = __webpack_public_path__ + "static/rebass.a740d518.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/examples/thumbnails/rebass.png
// module id = 856
// module chunks = 73261030922168